import React, { useEffect, useState } from "react";
import { notification, Select } from "antd";
import {
  InfoCircleOutlined,
  CheckCircleOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import { Link, useLocation, useNavigate } from "react-router-dom"

import { addeditdata } from '../../../controllers/V1/promocodes/promocodeController'

import LoadingEffect from "../../../components/Loading/LoadingEffect";
import { usePermissions } from "../../../controllers/PermissionContext";
const PromocodeEditPage = () => {
  const PERMISSION = usePermissions("promoCodes");
  const location = useLocation();
  const state = location.state;
  const navigate = useNavigate();
  const [error, setError] = useState([]);
  const [ADDEDITDATA, setAddEditData] = useState(state || []);

  const [isLoading, setIsLoading] = useState(false);

  /*********************************************************
   *  This function is use to handle input change
   *********************************************************/
  const handleChange = (e) => {
    setAddEditData((pre) => ({
      ...pre,
      [e.target.name]: e.target.value,
    }));
    setError((pre) => ({
      ...pre,
      [e.target.name]: "",
    }));
  };

  /*********************************************************
   *  This function is use to handle form submit
   *********************************************************/
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const form = new FormData(event.target);

      const users_type = form.get('users_type');
      const params = {
        editId: form.get('edit_id'),
        // users_type              : users_type,
        code: form.get('code'),
        title: form.get('title'),
        description: form.get('description'),
        valid_date: form.get('valid_date'),
        expire_date: form.get('expire_date'),
        voucher_expire_date : form.get('voucher_expire_date'),
        points: form.get('points') || 0,
        seq_order : form.get('seq_order') || 1
      }
      const isValidate = await validateFormData(params);
      if (isValidate === true) {
        const res = await addeditdata(params);
        if (res.status === true) {
          notification.open({
            message: "Success.",
            description: `Data successfully added.`,
            placement: "topRight",
            icon: <CheckCircleOutlined style={{ color: "green" }} />,
            duration: 2,
          });
          navigate('/promocodes/list')
        } else {
          notification.open({
            message: "Oops!.",
            description: `${res.message}`,
            placement: "topRight",
            icon: <InfoCircleOutlined style={{ color: "red" }} />,
            duration: 2,
          });
        }
      } else {
        // console.log('validation error',error);
        notification.open({
          message: "Oops!",
          description: `Validation Error.`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
          duration: 2,
        });
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  /*********************************************************
   *  This function is used to validate form data before submit
   *********************************************************/
  const validateFormData = (formData) => {
    try {
      const {
        code,
        title,
        description,
        points,
        expire_date,
        valid_date,
      } = formData;

      let status = false;
      let msg = 'noError';
      let error_field = 'noError';
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!code) {
        error_field = 'code';
        msg = "Promocode is required";
        status = false;
      } else if (!title) {
        error_field = 'title';
        msg = "Title is required";
        status = false;
      } else if (!description) {
        error_field = 'description';
        msg = "Description is required";
        status = false;
      } else if (!points) {
        error_field = 'points';
        msg = "Points are required";
        status = false;
      } else if (!valid_date) {
        error_field = 'valid_date';
        msg = "Valid date is required";
        status = false;
      } else if (!expire_date) {
        error_field = 'expire_date';
        msg = "Expire date is required";
        status = false;
      } else if (new Date(valid_date) > new Date(expire_date)) {
        error_field = 'expire_date';
        msg = "Expire date must be after the valid date";
        status = false;
      } else {
        status = true;
      }

      if (!status && setError) {
        setError((prevError) => ({
          ...prevError,
          [error_field]: msg,
        }));
      }

      return status;
    } catch (error) {
      console.log('error', error);
      return false;
    }
  };


  useEffect(() => {
    document.title = `Orbit Kuwait || ${ADDEDITDATA?._id ? "Edit" : "Add"
      } Promo Code`;
  }, []);

  return (
    <div>
      {" "}
      <div className="container-fluid">
        <div className="Inventory_edit_page_main_div">
          <React.Fragment>
            <h5 className="inventory_edit_page_heading"> {ADDEDITDATA?._id ? `Edit` : `Add`} Promocode </h5>
          </React.Fragment>
          <Link to={"/promocodes/list"}>
            <React.Fragment>
              <button type="button" className="btn btn-secondary"> <ArrowLeftOutlined /> Back </button>
            </React.Fragment>
          </Link>
        </div>

        <div className="card shadow mb-4 dataBase_table_Add_Data">
          <div className="card-body">
            <div className="responsive">
              <form method="post" className="inventory_form_main_contnet" onSubmit={handleSubmit}>
                <input type="hidden" name="edit_id" id="edit_id" value={ADDEDITDATA._id || ''} />
                <input type="hidden" name="country_code" id="country_code" value={ADDEDITDATA?.country_code || '+973'} />
                <input type="hidden" name="users_mobile" id="users_mobile" value={ADDEDITDATA?.users_mobile || ''} />
                <input type="hidden" name="bind_person_name" id="bind_person_name" value={ADDEDITDATA?.bind_person_name || ''} />
                <input type="hidden" name="bind_user_type" id="bind_user_type" value={ADDEDITDATA?.bind_user_type || ''} />
                <input type="hidden" name="bind_person_id" id="bind_person_id" value={ADDEDITDATA?.bind_person_id || ''} />
                <input type="hidden" name="bind_person_mobile" id="bind_person_mobile" value={ADDEDITDATA?.bind_person_mobile || ''} />

                <div className="row">
                  <div className="form-group col-lg-4 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label htmlFor="users_name" className="all_section_for_label_main_class">
                      <span style={{ color: "red" }}>*</span>Code :{" "}
                    </label>
                    <input
                      title="Enter Promocode."
                      placeholder="Enter Promocode."
                      type="text"
                      name="code"
                      className="form-control store_input_field"
                      id="code"
                      value={ADDEDITDATA?.code}
                      onChange={handleChange}
                    />
                    {error.promocode ? <p style={{ color: "red" }}>{error.promocode}</p> : ""}
                  </div>

                  <div className="form-group col-lg-4 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label htmlFor="last_name" className="all_section_for_label_main_class">
                      <span style={{ color: "red" }}>*</span>Title :{" "}
                    </label>
                    <input
                      title="Enter title name."
                      placeholder="Enter title name."
                      type="text"
                      name="title"
                      className="form-control store_input_field"
                      id="title"
                      value={ADDEDITDATA?.title}
                      onChange={handleChange}
                    />
                    {error.title ? <p style={{ color: "red" }}>{error.title}</p> : ""}
                  </div>

                  <div className="form-group col-lg-4 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label htmlFor="area" className="all_section_for_label_main_class">
                      <span style={{ color: "red" }}>*</span>Description :{" "}
                    </label>
                    <input
                      title="description"
                      placeholder="Description"
                      type="text"
                      name="description"
                      className="form-control store_input_field"
                      id="description"
                      value={ADDEDITDATA?.description}
                      onChange={handleChange}
                    />
                    {error.description ? <p style={{ color: "red" }}>{error.description}</p> : ""}
                  </div>
                  <div className="form-group col-lg-4 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label htmlFor="totalArabianPoints" className="all_section_for_label_main_class">Points:</label>
                    <input
                      title="Points"
                      placeholder="Points"
                      type="number"
                      name="points"
                      className="form-control store_input_field"
                      id="points"
                      value={ADDEDITDATA?.points}
                      onChange={handleChange}
                    />
                    {error.points ? <p style={{ color: "red" }}>{error.points}</p> : ""}
                  </div>
                  {/* New Fields for Valid From and Expire Date */}
                  <div className="form-group col-lg-4 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label htmlFor="valid_date" className="all_section_for_label_main_class">
                      <span style={{ color: "red" }}>*</span>Valid From:
                    </label>
                    <input
                      title="Select the start date."
                      type="date"
                      name="valid_date"
                      className="form-control store_input_field"
                      id="valid_date"
                      value={
                        ADDEDITDATA?.valid_date
                          ? new Date(ADDEDITDATA.valid_date).toISOString().split("T")[0]
                          : ""
                      }
                      onChange={handleChange}
                    />
                    {error.valid_date ? <p style={{ color: "red" }}>{error.valid_date}</p> : ""}
                  </div>

                  <div className="form-group col-lg-4 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label htmlFor="expire_date" className="all_section_for_label_main_class">
                      <span style={{ color: "red" }}>*</span>Expire Date:
                    </label>
                    <input
                      title="Select the expiry date."
                      type="date"
                      name="expire_date"
                      className="form-control store_input_field"
                      id="expire_date"
                      value={
                        ADDEDITDATA?.expire_date
                          ? new Date(ADDEDITDATA.expire_date).toISOString().split("T")[0]
                          : ""
                      }
                      onChange={handleChange}
                    />
                    {error.expire_date ? <p style={{ color: "red" }}>{error.expire_date}</p> : ""}
                  </div>

                  <div className="form-group col-lg-4 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label htmlFor="expire_date" className="all_section_for_label_main_class">
                      <span style={{ color: "red" }}>*</span>{`Voucher Expire (in Days)`}:
                    </label>
                    <input
                      title="Select the expiry date."
                      type="number"
                      name="voucher_expire_date"
                      className="form-control store_input_field"
                      id="voucher_expire_date"
                      value={ ADDEDITDATA?.voucher_expire_date }
                      onChange={handleChange}
                    />
                    {error.voucher_expire_date ? <p style={{ color: "red" }}>{error.voucher_expire_date}</p> : ""}
                  </div>

                  <div className="form-group col-lg-4 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label htmlFor="expire_date" className="all_section_for_label_main_class">
                      <span style={{ color: "red" }}>*</span>Seq. order:
                    </label>
                    <input
                      title="Select the expiry date."
                      type="number"
                      name="seq_order"
                      className="form-control store_input_field"
                      id="seq_order"
                      value={ ADDEDITDATA?.seq_order }
                      onChange={handleChange}
                    />
                    {error.expire_date ? <p style={{ color: "red" }}>{error.expire_date}</p> : ""}
                  </div>


                </div>

                <div className="inventory_edit_submit_btn">
                  <button type="submit" className="btn btn-primary inventory_save_button" disabled={(PERMISSION?.fullAccess === 'Y' || PERMISSION?.addEdit === 'Y') ? false : true}>Save</button>
                </div>
              </form>

            </div>
          </div>
        </div>
      </div>
      <LoadingEffect isLoading={isLoading} />
    </div>
  );
};

export default PromocodeEditPage;
